import { Component } from "react"
import PropTypes from "prop-types"
import StatCard from "./../stat_card"
import Tooltip from "./../tooltip"
import { fixedPercentValue } from "../lib"
import "./top_categories.scss"

export default class TopCategoryComponent extends Component {
  render() {
    const {
      categoryName,
      categoryId,
      activeUsers,
      serviceEngagement,
      comparisonWindow,
      userChangeRate,
      serviceEngagementChangeRate,
      topServices,
      connectionPercentage,
      categoriesUrl,
      servicesUrl,
      onDetailSelect,
      serviceName,
    } = this.props

    return (
      <div styleName="top-category-component-container">
        <div styleName="top-category-component-header">
          <div styleName="header-left">
            <h3>{categoryName}</h3>
            <span>
              {`${fixedPercentValue(
                connectionPercentage
              )}% of your connections are in this category`}
            </span>
          </div>
          <div className="tooltip-container">
            <Tooltip
              content={`Summary of ${serviceName} users and their enabled Applets with services in the ${categoryName} category`}
            />
          </div>
        </div>
        <div styleName="top-category-component-body">
          <div styleName="top-category-component-details">
            <div styleName="top-category-component-stats ">
              <StatCard
                stat={activeUsers}
                changeRate={userChangeRate}
                statText={`Users with enabled Applets last ${comparisonWindow} days`}
                className="categories"
                timePeriodInDays={comparisonWindow}
                compactThreshold={99999}
              />
              <div styleName="vertical-divider" />
              <StatCard
                stat={serviceEngagement}
                changeRate={serviceEngagementChangeRate}
                statText={"Service engagement"}
                className="categories"
                timePeriodInDays={comparisonWindow}
                compactThreshold={99999}
              />
            </div>
            <div>
              <div styleName="vertical-divider" />
            </div>
            <div styleName="top-category-component-services">
              <h4>Top {categoryName} services</h4>
              <div>
                {topServices.map((service, ind) => (
                  <a
                    href={`${servicesUrl}/${service.module_name}`}
                    styleName="service-info-container"
                    style={{
                      backgroundColor: `#${service.brand_color}`,
                    }}
                    key={ind}
                  >
                    <img src={service.monochrome_image_url} />
                    {service.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="action-buttons-container">
            <a
              role="button"
              className="button-secondary button-outlined"
              href={categoriesUrl}
              onClick={e => {
                if (onDetailSelect) {
                  e.preventDefault()
                  onDetailSelect(categoryId)
                }
              }}
            >
              View more detail
            </a>
          </div>
        </div>
      </div>
    )
  }
}

TopCategoryComponent.propTypes = {
  categoryName: PropTypes.string,
  categoryId: PropTypes.string,
  serviceName: PropTypes.string,
  comparisonWindow: PropTypes.number,
  activeUsers: PropTypes.number,
  userChangeRate: PropTypes.number,
  serviceEngagementChangeRate: PropTypes.number,
  serviceEngagement: PropTypes.number,
  connectionPercentage: PropTypes.number,
  topServices: PropTypes.arrayOf(PropTypes.object),
  numberOfServices: PropTypes.number,
  categoriesUrl: PropTypes.string,
  servicesUrl: PropTypes.string,
  onDetailSelect: PropTypes.func,
}
